"use client";

import type { ReactNode } from "react";
import { cn } from "@dionatanbig2be/big2be-ui/utils";

interface ScrollArrowProps {
    side: "left" | "right";
    onClick: () => void;
    /** Cores do ícone (cada variante usa sua paleta). */
    className?: string;
    children: ReactNode;
}

/**
 * Seta de scroll ancorada na borda da barra, com o gradiente que desvanece o
 * conteúdo por baixo. Compartilhada pelas variantes 1 e 2 do CategoryNav.
 */
export function ScrollArrow({ side, onClick, className, children }: ScrollArrowProps) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={side === "left" ? "Anterior" : "Próximo"}
            className={cn(
                "absolute inset-y-0 z-10 flex items-center from-base-100 via-base-100/90 to-transparent transition-colors",
                side === "left" ? "left-0 bg-linear-to-r pl-1 pr-4" : "right-0 bg-linear-to-l pl-4 pr-1",
                className
            )}
        >
            {children}
        </button>
    );
}
